module.exports = __webpack_public_path__ + "media/images/emblems/Ennetmoos-coat_of_arms-c24031c2d8b3173e43dc4b9a96a3109f.svg";